// extracted by mini-css-extract-plugin
export default {"image":"f4-z","loaded":"g4-z"};